<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="方案名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="[
              'schemeName',
              { rules: [{ required: true, message: '请输入方案名称!' }] }
            ]"
            placeholder="请输入方案名称"
          />
        </a-form-item>
        <a-form-item label="方案描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea
            v-decorator="['description']"
            :rows="2"
            placeholder="请输入方案描述"
          />
        </a-form-item>
        <a-form-item label="平台配置" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-table
            :columns="platformColumns"
            :dataSource="platformDetails"
            :pagination="false"
            size="small"
            :rowKey="record => record.platformCode"
          >
            <template slot="priority" slot-scope="text, record, index">
              <a-input-number
                v-model="record.priority"
                :min="1"
                @change="(value) => handlePriorityChange(value, record)"
              />
            </template>
            <template slot="enabled" slot-scope="text, record">
              <a-switch
                :checked="record.enabled === 1"
                @change="(checked) => handleEnabledChange(checked, record)"
              />
            </template>
          </a-table>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { postAction, getAction, putAction } from '@/api/manage'
import pick from 'lodash.pick'

const platformColumns = [
  {
    title: '平台名称',
    dataIndex: 'platformName',
    key: 'platformName',
    width: 120
  },
  {
    title: '平台编码',
    dataIndex: 'platformCode',
    key: 'platformCode',
    width: 120
  },
  {
    title: '优先级',
    dataIndex: 'priority',
    key: 'priority',
    width: 100,
    scopedSlots: { customRender: 'priority' }
  },
  {
    title: '是否启用',
    dataIndex: 'enabled',
    key: 'enabled',
    width: 100,
    scopedSlots: { customRender: 'enabled' }
  }
]

export default {
  name: 'PlatformSchemeModal',
  data() {
    return {
      title: '',
      visible: false,
      model: {},
      platformTypes: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      confirmLoading: false,
      form: this.$form.createForm(this),
      platformColumns,
      platformDetails: [],
      url: {
        add: '/message/platform/scheme/create',
        edit: '/message/platform/scheme/update',
        detail: '/message/platform/scheme/detail',
        platformTypes: '/message/platform/scheme/platformTypes'
      }
    }
  },
  methods: {
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.title = record ? '修改方案' : '新增方案'

      if (record) {
        // 加载方案明细
        getAction(`${this.url.detail}/${record.id}`).then(res => {
          if (res.success) {
            this.platformDetails = res.result
          }
        })
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, ['schemeName', 'description']))
        })
      } else {
        // 新增时加载平台类型列表
        this.loadPlatformTypes()
      }
    },
    loadPlatformTypes() {
      getAction(this.url.platformTypes).then(res => {
        if (res.success) {
          // 将后端返回的平台类型转换为表格数据格式
          this.platformDetails = res.result.map((item, index) => {
            return {
              platformName: item.name,
              platformCode: item.code,
              priority: index + 1,
              enabled: 1
            }
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleOk() {
      const that = this
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let formData = {
            scheme: {
              ...values,
              id: this.model.id
            },
            details: this.platformDetails
          }

          let httpurl = this.model.id ? this.url.edit : this.url.add
          let method = this.model.id ? putAction : postAction

          method(httpurl, formData).then((res) => {
            if (res.success) {
              that.$message.success(res.message)
              that.$emit('ok')
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.form.resetFields()
      this.platformDetails = []
      this.platformTypes = []
    },
    handlePriorityChange(value, record) {
      // 检查优先级是否重复
      const duplicate = this.platformDetails.find(item =>
        item.platformCode !== record.platformCode && item.priority === value
      )
      if (duplicate) {
        this.$message.error('优先级不能重复！')
        record.priority = this.getAvailablePriority()
      }
    },
    getAvailablePriority() {
      const priorities = this.platformDetails.map(item => item.priority)
      let priority = 1
      while (priorities.includes(priority)) {
        priority++
      }
      return priority
    },
    handleEnabledChange(checked, record) {
      record.enabled = checked ? 1 : 0
    }
  }
}
</script>